import { useTranslation } from 'react-i18next'

import { ArrowUDownLeft } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Alert, DeliveryMethod, Text } from '@reveni-io/reveni-ui'

const DeliveryMethods = ({ deliveryMethods, regions, onSelectDeliveryMethod }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const getTitle = () => {
    if (deliveryMethods?.length === 1) {
      return `${deliveryMethods?.length} ${t('método de devolución')}`
    }

    return `${deliveryMethods?.length} ${t('métodos de devolución')}`
  }

  return (
    <>
      {deliveryMethods?.length > 0 ? (
        <>
          <Text
            type="titleS"
            customStyles={{
              display: 'flex',
              alignItems: 'center',
              gap: theme.spacing.sp4,
            }}
          >
            <ArrowUDownLeft size={24} weight="light" /> {getTitle()}:
          </Text>
          {deliveryMethods?.map(method => (
            <DeliveryMethod
              key={method.id}
              data={method}
              regions={regions}
              isEditable={false}
              showSwitch={false}
              onEdit={() => onSelectDeliveryMethod(method)}
              customBackgroundColor={theme.colors.background.secondary}
              containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16}`}
            />
          ))}
        </>
      ) : (
        <Alert type="info">{t('Esta ubicación aún no está asociada a ningún método de devolución.')}</Alert>
      )}
    </>
  )
}

export default DeliveryMethods
